import { Helmet } from 'react-helmet';
import { Box, Container, Typography } from '@mui/material';

const PaymentFailed = () => (
  <>
    <Helmet>
      <title>Payment Failed | Milkton</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center'
      }}
    >
      <Container maxWidth="md">
        <Typography align="center" color="textPrimary" variant="h1">
          😢: Oops! Transaction Failed
        </Typography>
        <Box p={1} />
        <Typography align="center" color="textPrimary" variant="subtitle2">
          Please try again later. If any amount has been deducted, it will be
          refunded automatically.
        </Typography>
        <Box sx={{ textAlign: 'center' }}>
          <img
            alt="Payment Failed"
            src="/static/images/wrong.png"
            style={{
              marginTop: 50,
              display: 'inline-block',
              maxWidth: '100%',
              width: 560
            }}
          />
        </Box>
      </Container>
    </Box>
  </>
);

export default PaymentFailed;
